import { useTranslation } from 'react-i18next'

import { useDate, useDateLocale } from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import { useGretaAIChatContext } from '../GretaAIChat.hooks'
import {
  getGretaAIChatErrorTextKey,
  getIsGretaAIChatIdle,
  getIsGretaAIChatLoading,
  getIsGretaAIChatRetryableStatus,
} from '../GretaAIChat.utils'
import { getHasGretaAIChatProjects } from '../GretaAIChat.utils.projects'

import { QA_NAME_GRETA_AI_CHAT_PROJECTS_PAGE } from './GretaAIChatProjectsPage.constants'
import { GretaAIChatProjectsPageGrid } from './GretaAIChatProjectsPageGrid'
import { GretaAIChatProjectsPageHeader } from './GretaAIChatProjectsPageHeader'
import { GretaAIChatProjectsPageSkeleton } from './GretaAIChatProjectsPageSkeleton'
import { GretaAIChatProjectsPageState } from './GretaAIChatProjectsPageState'

import * as styles from './GretaAIChatProjectsPage.module.css'

function GretaAIChatProjectsPage() {
  const { t } = useTranslation()
  const now = useDate()
  const locale = useDateLocale()

  const { projects: projectsData } = useGretaAIChatContext()
  const { loadProjects, projects, projectsStatus } = projectsData

  const isLoading = getIsGretaAIChatLoading(projectsStatus)
  const isIdle = getIsGretaAIChatIdle(projectsStatus)
  const isError = !isLoading && !isIdle
  const isRows = isIdle && getHasGretaAIChatProjects(projects)
  const isRetryable = getIsGretaAIChatRetryableStatus(projectsStatus)
  const errorTextKey = getGretaAIChatErrorTextKey(projectsStatus)

  return (
    <div
      {...getQaSelector({ value: QA_NAME_GRETA_AI_CHAT_PROJECTS_PAGE })}
      className={styles.page}
    >
      <div className={styles.column}>
        <GretaAIChatProjectsPageHeader
          count={projects.length}
          isCountShown={isIdle}
        />

        {isLoading ? (
          <GretaAIChatProjectsPageSkeleton />
        ) : isRows ? (
          <GretaAIChatProjectsPageGrid
            locale={locale}
            now={now}
            projects={projects}
          />
        ) : (
          <GretaAIChatProjectsPageState
            text={isError ? t(errorTextKey) : t('Greta.ProjectsEmptyTextKey')}
            title={
              isError
                ? t('Greta.ProjectsLoadErrorTitleKey')
                : t('Greta.ProjectsEmptyTitleKey')
            }
            onRetry={isError && isRetryable ? loadProjects : null}
          />
        )}
      </div>
    </div>
  )
}

export default GretaAIChatProjectsPage
